<template>
  <el-popover
      v-model="visible"
      placement="top"
      width="160">
    <p style="font-size: 16px; word-break: break-word; text-align: initial; color: #606266">
      This device(s) will be unlinked
    </p>
    <div style="text-align: right; margin: 0">
      <el-button
          size="mini"
          type="text"
          @click="visible = false">
        cancel
      </el-button>
      <el-button
          :loading="unlinking"
          type="primary"
          size="mini"
          @click="unlink">
        confirm
      </el-button>
    </div>

    <el-button
        slot="reference"
        type="text">
      <el-tooltip
          class="item"
          effect="dark"
          :content="tooltip"
          placement="top-start">
        <slot> </slot>
      </el-tooltip>
    </el-button>
  </el-popover>
</template>
<script>
import axios from "axios";

export default {
  name: "UnlinkDevices",
  props: {
    customerId: {
      type: [Number, String],
      default: 0,
    },
    deviceId: {
      type: [Number, String],
      default: 0,
    },
    appBrand: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "Unlink All Devices",
    },
  },
  data() {
    return {
      unlinking: false,
      visible: false,
    };
  },
  methods: {
    unlink() {
      let request;
      if (this.deviceId)
        request = axios.delete(`/v2/client_devices/${this.deviceId}.json`, {
          data: {
            app_brand: this.appBrand || "ring",
            user_id: this.customerId,
          },
        });
      else if (this.customerId)
        request = axios.put(
          `/v2/customers/${this.customerId}/unlink_client_devices.json`
        );

      if (!request) {
        console.error("Cannot unlink device if not id or customer_id is given");
        return;
      }
      this.unlinking = true;
      request
        .then((response) => {
          this.$message({
            message: "Device(s) unlinked successfully",
            type: "success",
          });
          this.$emit("onSucceed");
        })
        .catch((error) => {
          this.$message.error("Device(s) could not be unlinked");
        })
        .finally(() => {
          this.unlinking = false;
          this.visible = false;
        });
    },
  },
};
</script>
